module.exports = __webpack_public_path__ + "img/tire.975d0cb0.jpg";